__turbopack_context__.v({
  "content": "page-module___8aEwW__content",
  "wrapper": "page-module___8aEwW__wrapper",
});
